import React from 'react';
import CancelAction from './CancelAction';

export default function EventScheduleActions({ eventItem, eventItems, setValue, rescheduleItem }) {
  const cancelEventItem = () => {
    const updatedEvents = eventItems.filter(current => { return current.id !== eventItem.id });
    setValue('eventItems', updatedEvents);
  }

  return <CancelAction type={eventItem.type} cancelEventItem={cancelEventItem} />
}